import { render, staticRenderFns } from "./ticket-open-consign.vue?vue&type=template&id=48715c64&scoped=true&"
import script from "./ticket-open-consign.vue?vue&type=script&lang=js&"
export * from "./ticket-open-consign.vue?vue&type=script&lang=js&"
import style0 from "./ticket-open-consign.vue?vue&type=style&index=0&id=48715c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48715c64",
  null
  
)

export default component.exports